<script>
  import {
    CheckIcon,
  } from 'vue-feather-icons'
  import {
    generateId,
  } from '../plugins/utils.js'

  export default {
    name: 'FabricCheckbox',
    components: {
      CheckIcon,
    },
    model: {
      prop: 'modelValue',
      event: 'update'
    },
    props: {
      // modelValue prop should Never have a default
      // eslint-disable-next-line vue/require-default-prop
      modelValue: null,
      id: {
        type: [String, Number],
        default: (() => generateId()),
      },
      defaultSelected: {
        type: Boolean,
        default: false,
      },
      value: {
        type: [Boolean, String, Number, Object],
        default: true,
      },
      slotClasses: {
        type: String,
        default: '',
      },
      switch: {
        type: Boolean,
        default: false,
      },
      isStacked: {
        type: Boolean,
        default: false,
      },
      customWidth: {
        type: Number,
        default: 20,
      },
      noLabel: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        modelValueBound: false, // assume not bound unless in `created` we can validate binding
        isSelected: false,
      }
    },
    computed: {
      computedId(){
        return `${this.id}__fb_checkbox__`
      },
      isSwitch(){
        return this.switch
      },
      resolveTransitionClass(){
        if(this.isSelected && !this.isStacked){
          return `before:tw-translate-x-[${this.customWidth}px]`
        }
        return ''
      },
      antiClassPurge(){
        return [
          'before:tw-translate-x-[19px]',
          'before:tw-translate-x-[20px]',
          'tw-translate-x-[19px]',
          'tw-translate-x-[20px]',
        ]
      }
    },
    watch:{
      modelValue(newValue, oldValue){
        this.isSelected = newValue
      }
    },
    created(){
      this.modelValueBound = Object.keys(this.$options.propsData).indexOf('modelValue') !== -1
      if (this.modelValueBound){
        if (typeof this.modelValue === 'boolean'){
          this.isSelected = this.modelValue
        }else{
          this.isSelected = Boolean(this.value === this.modelValue)
        }
      }else{
        this.isSelected = this.defaultSelected
      }
    },
    methods:{
      toggleChange(event){
        if(this.disabled){
          return
        }
        this.isSelected = !this.isSelected
        if (this.isSelected){
          this.$emit('update', this.value)
        }else{
          this.$emit('update', null)
        }
      }
    }
  }
</script>

<template>
  <section
    :id="id + '__fb_checkbox__'"
    :class="[
      'tw-flex tw-flex-row tw-items-center',
      { 
        'tw-pr-6': !noLabel,
      }]">
    <article>
      <label
        v-if="isSwitch"
        :for="id + '__fb_checkbox__input'" 
        :class="[
          'tw-h-5 tw-w-10',
          'tw-inline-flex tw-items-center',
          'tw-rounded-[10px]',
          'tw-bg-white',
          'tw-border-gray-400 tw-border',
          'tw-transition-[color]',
          'tw-cursor-pointer',
          'tw-justify-start',
          'before:tw-bg-gray-400',
          'before:tw-transition',
          'before:tw-transform',
          'before:tw-left-0', 
          'before:tw-relative',
          'before:tw-h-4 before:tw-w-4',
          'before:tw-rounded-[10px]',
          '!tw-py-[2.5px] !tw-pr-[2.5px] !tw-pl-[1.5px]',
          resolveTransitionClass,
          {
            '!tw-bg-emerald-500': isSelected,
            '!tw-border-emerald-500': isSelected,
            '!tw-cursor-default': disabled,
            'before:tw-translate-x-[19px]': isSelected && isStacked,
            'tw-mb-0': isStacked,
            'before:!tw-bg-white': isSelected,
            'before:!tw-cursor-default': disabled,
          }]"/>
      <label
        v-else
        :for="id + '__fb_checkbox__input'" 
        :class="[
          'tw-h-[15px] tw-w-[15px]',
          'tw-mb-u',
          'tw-inline-flex tw-justify-center tw-items-center',
          'tw-border tw-border-gray-300 tw-rounded-[3px]',
          'tw-bg-gray-300',
          'tw-transition-[background]',
          'tw-cursor-pointer',
          '!tw-pb-u !tw-pl-u', // remove global inherited values
          {
            '!tw-bg-primary !tw-border-primary': isSelected,
          }]"><CheckIcon v-if="isSelected" size='0.75x' class="tw-text-white tw-stroke-[4]" /></label>
      <input 
        :id="id + '__fb_checkbox__input'" 
        class="tw-hidden"
        type="checkbox"
        :checked="isSelected"
        :value="value"
        @change.self.prevent="toggleChange">
    </article>
    <article 
      v-if="!noLabel"
      class="tw-w-auto">
      <label 
        ref="slotLabel"
        :for="id + '__fb_checkbox__input'" 
        :class="[
          'tw-font-semibold tw-text-sm !tw-leading-[17px]',
          slotClasses,
          {
            'tw-mb-u tw-mt-[-0.375rem] tw-pl-6': !slotClasses,
          }]"><slot/></label>
    </article>
  </section>
</template>
